<template>
  <div class="nf">
    <div class="nf__card">
      <span class="nf__code">404</span>
      <h1 class="nf__title">Página no encontrada</h1>
      <p class="nf__text">La dirección que buscas no existe.</p>
      <router-link to="/" class="nf__link">Ir al inicio</router-link>
    </div>
  </div>
</template>

<style scoped>
.nf { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #e6eaf3; padding: 1rem; }
.nf__card { text-align: center; }
.nf__code { font: 700 56px var(--font-display); color: #1e3a5f; }
.nf__title { margin: 4px 0; font: 700 18px var(--font-display); color: #1e3a5f; }
.nf__text { margin: 0 0 16px; font: 400 14px Inter, sans-serif; color: #64748b; }
.nf__link { font: 500 14px Inter, sans-serif; color: #3b82f6; text-decoration: none; }
</style>